<div class="no-scroll patient-ob">
  <div class="wrapper">
    <!-- ========================== Print History Popup (Start) ========================== -->
    <div *ngIf="showPrintHistoryPopup" class="print-history-popup">
      <div class="print-history-popup-body">
        <h2 class="popup-title">{{ "GUI.Patient History.PrintHistory.Print History" | translate }}</h2>
        <button
          (click)="togglePrintHistoryPopup()"
          class="print-history-popup-close"
          aria-label="close popup"
        ></button>

        <img *ngIf="loadingPrint" src="../../assets/images/Wedges.svg" class="pdf-loader" />

        <table
          mat-table
          [dataSource]="printHistoryData"
          *ngIf="!loadingPrint"
          class="mat-elevation-z8 print-table"
        >
          <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let element">
              {{ printHistoryData.indexOf(element) + 1 }}
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>
              {{ "GUI.Patient History.PrintHistory.Date" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.creationDate | date : "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="time">
            <th mat-header-cell *matHeaderCellDef>
              {{ "GUI.Patient History.PrintHistory.Hour" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.creationTime }}
            </td>
          </ng-container>

          <ng-container matColumnDef="comments">
            <th mat-header-cell *matHeaderCellDef>
              {{ "GUI.Patient History.PrintHistory.Comments" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.comments }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            (click)="printSelectPDF(row)"
            [class.demo-row-is-clicked]="clickedRows.has(row)"
            *matRowDef="let row; columns: displayedColumns"
          ></tr>
        </table>
      </div>
    </div>
    <!-- ========================== Print History Popup (End) ========================== -->

    <!-- ========================== Header (Start) ========================== -->
    <header class="l-header">
      <div class="on-mobile header-logo">
        <img src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
      </div>
      <div class="l-header-panel">
        <i class="off-mobile header-icon icon-fetus" *ngIf="false"></i>

        <div class="header-pagi" *ngIf="false">
          <a href="#" class="header-pagi-item">1</a>
          <a href="#" class="header-pagi-item is-active">2</a>
          <a href="#" class="header-pagi-item">3</a>
        </div>

        <nav class="header-menu">
          <!-- <a href="#" class="header-menu-link icon-book" aria-label="library"></a> -->
          <!-- <a href="#" class="header-menu-link icon-print" aria-label="Print"></a> -->
          <img
            style="cursor: pointer; margin-right: 2em"
            matTooltip="Attach Document"
            height="41em"
            width="41em"
            (click)="openDocumentsAdd = true"
            src="../../assets/icons/fileupload.svg"
          />
          <img
            *ngIf="login.hasPremission('Billings')"
            style="cursor: pointer; margin-right: 2em"
            matTooltip="Get Invoice"
            (click)="redirectAdministration('billing')"
            height="41em"
            width="41em"
            src="../../assets/icons/billings-white.svg"
          />
          <img
            *ngIf="login.hasPremission('Appointments')"
            style="cursor: pointer"
            matTooltip="Set Appointment"
            (click)="redirectAdministration('appointments')"
            height="41em"
            width="41em"
            src="../../assets/icons/calendar-white.svg"
          />
          <!-- <a href="#" class="header-menu-link icon-chart" aria-label="chart"></a> -->
          <!-- <a href="#" class="header-menu-link icon-image" aria-label="image"></a> -->
          <!-- <a href="#" class="header-menu-link icon-searchdoc" aria-label="image"></a> -->
          <!-- <a href="#" class="header-menu-link icon-save" aria-label="save"></a> -->
          <!-- <a href="#" class="header-menu-link icon-date" aria-label="date"></a> -->
          <!-- <a href="#" class="header-menu-link icon-confirm" aria-label="confirm"></a> -->
        </nav>

        <nav class="on-mobile header-mobilePanel">
          <button
            class="btn-mobileMenu"
            id="open-headerMenu"
            data-show=".header-menu"
            aria-label="open mobile menu"
          ></button>
          <button
            class="btn-mobileMenu"
            id="open-mainNav"
            data-show=".l-sidebar"
            aria-label="open mobile sidebar"
          ></button>
        </nav>
      </div>
    </header>
    <!-- ========================== Header (End) ========================== -->

    <!-- ========================== Dashboard Main Content (Start) ========================== -->

    <main class="l-deashboard">
      <div class="h100 l-flex l-flex-w t-boxMargin--spacebyPadding">
        <!-- ========================== Patient History Panel (Start) ========================== -->
        <div class="w50 patient-ob-box">
          <div
            class="h100 m-box"
            *ngIf="pat && pat.ID === 'default'"
            [formGroup]="examService.newTitleItem"
          >
            <h2>Additional Titles Setting</h2>
            <div class="h100 l-flex l-column" style="justify-content: space-between">
              <div>
                <div class="headDiv">
                  <div class="inputLine">
                    <section>
                      <span>Define new title:</span>
                      <input
                        class="input"
                        #inputTitle
                        type="text"
                        formControlName="Title"
                        [value]="examService.newTitleItem.get('Title').value"
                      />
                    </section>
                    <span class="t-validation-wrap l-fg1" style="text-align: center">
                      <span class="s-count" *ngIf="examService.CustomTitles">
                        <span [ngClass]="!examService.disableSaveTitle ? '' : 'is-invalid'">
                          <strong
                            >{{
                              examService.CustomTitles ? examService.CustomTitles.length : 0
                            }}/8</strong
                          >
                        </span>
                        <div class="t-validation-message">
                          <span>Maximum Custom Titles, Please Remove One</span>
                        </div>
                      </span>
                    </span>
                    <button
                      (click)="examService.saveNewTitle(login.ClinicID, false)"
                      style="background-color: #d7a95b; color: white; width: 4em; border-radius: 10px"
                    >
                      save
                    </button>
                  </div>
                </div>
                <div>
                  <div
                    class="linked-radios-list linked-radios-set"
                    style="margin-top: 0"
                    [formGroup]="examService.newTitleItem"
                  >
                    <label class="linked-radios-item" *ngFor="let c of examService.CustomTitles">
                      <input
                        type="radio"
                        [value]="c.AutoIndex"
                        formControlName="AutoIndex"
                        (click)="examService.getTitle(c.AutoIndex)"
                      />
                      <span class="linked-radios-row">
                        <span
                          class="l-fg1 linked-radios-title"
                          (dblclick)="examService.resetTitleItem()"
                          >{{ c.Title }}</span
                        >
                        <span class="linked-radios-duration" style="margin-inline-end: 5em">
                          <p>
                            {{ c.Creation | date : "dd/MM/yyyy" }} at {{ c.Creation | date : "HH:mm" }}
                          </p>
                        </span>
                        <span class="linked-radios-duration"
                          ><img
                            src="../../assets/icons/del.svg"
                            matTooltip="Delete"
                            (click)="examService.deleteTitle(c.AutoIndex)"
                        /></span>
                        <!-- <span class="linked-radios-duration"><img *ngIf="defaults && defaults['Fetal Echo']" src="../../assets/icons/del.svg" matTooltip="Delete" (click)='deleteDefault("Specialized")'> 12-40 Weeks</span> -->
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">
                <a class="patient-ob-btn -exit_patient" routerLink="/patsearch"> Exit Titles Setting </a>
                <!-- <button class="patient-ob-btn -start_exam" [ngClass]="examname && etype ? '': 'opaque'"
                                    (click)="startExam()" *ngIf="canOpen()">
                                    {{pat.ID != 'default' ? (etype!= 'Forms'?'Start Exam': 'New Letter') :
                                    'Construct/Edit Defaults'}}
                                </button> -->
              </div>
            </div>
          </div>
          <div class="h100 m-box" *ngIf="pat.ID != 'default' && !login.isGastro">
            <div *ngIf="similarPatientIdMsg" class="popup" style="display: block; max-width: 40vw">
              <div class="t-popup-frame">
                <div class="t-popup-body">
                  <button
                    (click)="similarPatientIdMsg = false"
                    class="t-btn-popup-close"
                    aria-label="close popup"
                  ></button>
                  <h2>
                    <strong> Patients with similar IDs where found: </strong>
                  </h2>
                  <div *ngFor="let patient of similarPatientIdArray">
                    <span>{{ patient.ID }}</span>
                  </div>
                </div>
              </div>
            </div>
            <h2>Patient History</h2>
            <!-- ========================== Echo Exams (Start) ========================== -->
            <div
              class="linked-radios-list linked-radios-set"
              *ngIf="notFormExams && notFormExams.length > 0"
            >
              <strong class="linked-radios-row" style="margin-bottom: 1em"> Echo </strong>

              <ul>
                <li class="l-flex l-flex-c" *ngFor="let exam of notFormExams">
                  <ng-container *ngIf="!FORMS.includes(exam.ExamType)">
                    <span
                      class="examlink"
                      style="display: flex; position: relative; width: 100%; align-items: center"
                      (contextmenu)="askDelete(exam)"
                    >
                      <span style="width: 45%">
                        <strong *ngIf="exam.Draft"> * </strong>

                        <span (click)="goExam(null, exam, exam.ExamType, exam.CreationTime)">
                          {{ exam.ExamType }}
                        </span>
                        <span *ngIf="exam.Changed"> ({{ exam.ChangedExamTitle }}) </span>
                        <ng-container *ngIf="exam.Locked">
                          <img src="../../assets/icons/login/password.svg" style="height: 1em" />
                          {{ exam.LockedBy }}
                        </ng-container>
                      </span>

                      <img
                        [ngClass]="
                          examService.awaitPrintHistory
                            ? 'print-history-icon-disabled'
                            : 'print-history-icon'
                        "
                        src="../../assets/icons/print-history.svg"
                        matTooltip="{{
                          showPrintHistoryPopup
                            ? ('GUI.Patient History.PrintHistory.Close Print History' | translate)
                            : ('GUI.Patient History.PrintHistory.Open Print History' | translate)
                        }}"
                        [matTooltipDisabled]="examService.awaitPrintHistory"
                        (click)="togglePrintHistoryPopup(); getPrintHistoryList(exam)"
                      />
                    </span>

                    <span style="width: 20%; margin-right: 2em; white-space: nowrap">
                      by {{ exam.Opener }}
                    </span>
                    <span
                      *ngIf="exam.SignedDate"
                      style="width: 20%; margin-right: 2em; white-space: nowrap"
                    >
                      Signed {{ exam.SignedDate | date : "dd/MM/yyyy" }}
                    </span>
                    <span
                      *ngIf="!exam.SignedBy"
                      style="width: 20%; margin-right: 2em; white-space: nowrap"
                    >
                      Not Reviewed
                    </span>
                    <span style="width: 20%" class="linked-radios-date">
                      {{ exam.CreationTime | date : "dd/MM/yyyy" }} at
                      {{ exam.CreationTime | date : "HH:mm" }}
                    </span>
                  </ng-container>
                </li>
              </ul>
            </div>
            <!-- ========================== Echo Exams (End) ========================== -->

            <!-- ========================== ECG Exams (Start) ========================== -->
            <div class="linked-radios-list linked-radios-set" *ngIf="ecgExams && ecgExams.length > 0">
              <strong class="linked-radios-row" style="margin-bottom: 1em"> ECG </strong>

              <ul>
                <li class="l-flex l-flex-c" *ngFor="let exam of ecgExams">
                  <ng-container *ngIf="!FORMS.includes(exam.ExamType)">
                    <span
                      class="examlink"
                      style="display: flex; position: relative; width: 100%; align-items: center"
                      (contextmenu)="askDelete(exam)"
                    >
                      <span style="width: 45%">
                        <strong *ngIf="exam.Draft"> * </strong>

                        <span (click)="goExam(null, exam, exam.ExamType, exam.CreationTime)">
                          {{ exam.ExamType }}
                        </span>
                        <span *ngIf="exam.Changed"> ({{ exam.ChangedExamTitle }}) </span>
                        <ng-container *ngIf="exam.Locked">
                          <img src="../../assets/icons/login/password.svg" style="height: 1em" />
                          {{ exam.LockedBy }}
                        </ng-container>
                      </span>

                      <img
                        [ngClass]="
                          examService.awaitPrintHistory
                            ? 'print-history-icon-disabled'
                            : 'print-history-icon'
                        "
                        src="../../assets/icons/print-history.svg"
                        matTooltip="{{
                          showPrintHistoryPopup
                            ? ('GUI.Patient History.PrintHistory.Close Print History' | translate)
                            : ('GUI.Patient History.PrintHistory.Open Print History' | translate)
                        }}"
                        [matTooltipDisabled]="examService.awaitPrintHistory"
                        (click)="togglePrintHistoryPopup(); getPrintHistoryList(exam)"
                      />
                    </span>

                    <span style="width: 20%; margin-right: 2em; white-space: nowrap">
                      by {{ exam.Opener }}
                    </span>
                    <span
                      *ngIf="exam.SignedDate"
                      style="width: 20%; margin-right: 2em; white-space: nowrap"
                    >
                      Signed {{ exam.SignedDate | date : "dd/MM/yyyy" }}
                    </span>
                    <span
                      *ngIf="!exam.SignedBy"
                      style="width: 20%; margin-right: 2em; white-space: nowrap"
                    >
                      Not Reviewed
                    </span>
                    <span style="width: 20%" class="linked-radios-date">
                      {{ exam.CreationTime | date : "dd/MM/yyyy" }} at
                      {{ exam.CreationTime | date : "HH:mm" }}
                    </span>
                  </ng-container>
                </li>
              </ul>
            </div>
            <!-- ========================== ECG Exams (End) ========================== -->

            <!-- ========================== Questionnaires (Start) ========================== -->
            <div
              class="linked-radios-list linked-radios-set"
              *ngIf="login.hasPremission('Questionnaires') && questionnaireList && questionnaireList.length > 0"
            >
              <strong class="linked-radios-row" style="margin-bottom: 1em">
                {{ 'GUI.General.Buttons.Questionnaires' | translate }}
              </strong>
              <ul>
                <li class="l-flex l-flex-c" *ngFor="let q of questionnaireList">
                  <span
                    class="l-fg1 examlink"
                    [style.cursor]="q.answeredDate ? 'pointer' : 'default'"
                    (click)="q.answeredDate && openQuestionnairePdf(q)"
                  >
                    {{ q.name }}
                  </span>
                  <span
                    style="border-radius: 1em; padding: 0.15em 0.8em; font-size: 0.85em; color: #fff; margin: 0 0.5em;"
                    [style.background]="q.answeredDate ? '#4caf50' : '#bbb'"
                  >
                    {{ q.answeredDate ? "Answered" : "Pending" }}
                  </span>
                  <span class="linked-radios-date">
                    {{ (q.answeredDate || q.sentDate) | date : "dd/MM/yyyy" }}
                  </span>
                </li>
              </ul>
            </div>
            <!-- ========================== Questionnaires (End) ========================== -->

            <!-- ========================== Pneumology Exams (Start) ========================== -->
            <div
              class="linked-radios-list linked-radios-set"
              *ngIf="PneumologyExams && PneumologyExams.length > 0"
            >
              <strong class="linked-radios-row" style="margin-bottom: 1em"> Pneumology </strong>

              <ul>
                <li class="l-flex l-flex-c" *ngFor="let exam of PneumologyExams">
                  <ng-container *ngIf="!FORMS.includes(exam.ExamType)">
                    <span
                      class="examlink"
                      style="display: flex; position: relative; width: 100%; align-items: center"
                      (contextmenu)="askDelete(exam)"
                    >
                      <span style="width: 45%">
                        <strong *ngIf="exam.Draft"> * </strong>

                        <span (click)="goExam(null, exam, exam.ExamType, exam.CreationTime)">
                          <!-- The exam name is too long to fit -->
                          {{
                            exam.ExamType === "Pulmonary functional assessment"
                              ? "Pulmonary"
                              : exam.ExamType === "Methacholine test"
                              ? "Methacholine test"
                              : exam.ExamType
                          }}
                        </span>
                        <span *ngIf="exam.Changed"> ({{ exam.ChangedExamTitle }}) </span>

                        <ng-container *ngIf="exam.Locked">
                          <img src="../../assets/icons/login/password.svg" style="height: 1em" />
                          {{ exam.LockedBy }}
                        </ng-container>
                      </span>
                      <img
                        [ngClass]="
                          examService.awaitPrintHistory
                            ? 'print-history-icon-disabled'
                            : 'print-history-icon'
                        "
                        src="../../assets/icons/print-history.svg"
                        matTooltip="{{
                          showPrintHistoryPopup
                            ? ('GUI.Patient History.PrintHistory.Close Print History' | translate)
                            : ('GUI.Patient History.PrintHistory.Open Print History' | translate)
                        }}"
                        [matTooltipDisabled]="examService.awaitPrintHistory"
                        (click)="togglePrintHistoryPopup(); getPrintHistoryList(exam)"
                      />
                    </span>

                    <span style="width: 20%; margin-right: 2em; white-space: nowrap">
                      by {{ exam.Opener }}
                    </span>
                    <span
                      *ngIf="exam.SignedDate"
                      style="width: 20%; margin-right: 2em; white-space: nowrap"
                    >
                      Signed {{ exam.SignedDate | date : "dd/MM/yyyy" }}
                    </span>
                    <span
                      *ngIf="!exam.SignedBy"
                      style="width: 20%; margin-right: 2em; white-space: nowrap"
                    >
                      Not Reviewed
                    </span>
                    <span style="width: 20%" class="linked-radios-date">
                      {{ exam.CreationTime | date : "dd/MM/yyyy" }} at
                      {{ exam.CreationTime | date : "HH:mm" }}
                    </span>
                  </ng-container>
                </li>
              </ul>
            </div>
            <!-- ========================== Pneumology Exams (End) ========================== -->

            <!-- ========================== Letters And Certificates (Start) ========================== -->
            <div
              class="linked-radios-list linked-radios-set"
              *ngIf="formsExams && formsExams.length > 0"
            >
              <strong class="linked-radios-row">Letters and Certificates </strong>

              <ul>
                <li class="l-flex l-flex-c" *ngFor="let exam of formsExams">
                  <ng-container *ngIf="FORMS.includes(exam.ExamType)">
                    <span
                      class="l-fg1 examlink"
                      (click)="goExam(null, exam, exam.ExamType, exam.CreationTime)"
                      (contextmenu)="askDelete(exam)"
                    >
                      <strong *ngIf="exam.Draft"> * </strong>
                      {{exam.Changed ? exam.ChangedExamTitle : exam.ExamType}}
                      <ng-container *ngIf="exam.Locked"
                        ><img src="../../assets/icons/login/password.svg" style="height: 1em" />{{
                          exam.LockedBy
                        }}</ng-container
                      >
                    </span>
                    <span style="margin-right: 2em">by {{ exam.Opener }}</span>
                    <span
                      *ngIf="exam.SignedDate"
                      style="width: 20%; margin-right: 2em; white-space: nowrap"
                    >
                      Signed {{ exam.SignedDate | date : "dd/MM/yyyy" }}
                    </span>
                    <span
                      *ngIf="!exam.SignedBy"
                      style="width: 20%; margin-right: 2em; white-space: nowrap"
                    >
                      Not Reviewed
                    </span>
                    <span class="linked-radios-date">
                      {{ exam.CreationTime | date : "dd/MM/yyyy" }} at
                      {{ exam.CreationTime | date : "HH:mm" }}
                    </span>
                  </ng-container>
                </li>
              </ul>
            </div>
            <!-- ========================== Letters And Certificates (End) ========================== -->

            <!-- ========================== Attached Documents (Start) ========================== -->
            <div
              class="linked-radios-list linked-radios-set"
              *ngIf="AttachedDocuments && AttachedDocuments?.length > 0"
            >
              <strong class="linked-radios-row" style="margin-bottom: 1em">Attached Documents </strong>

              <ul>
                <li
                  class="l-flex l-flex-c"
                  *ngFor="let document of AttachedDocuments | sortCreationTime : 'CreationTime'"
                >
                  <span
                    class="l-fg1 examlink"
                    (click)="openDocument(document.AutoIndex)"
                    (contextmenu)="askDelete(document, true)"
                  >
                    {{ document.title }}
                  </span>
                  <span style="margin-right: 2em"> {{ document.comments }}</span>
                  <span class="linked-radios-date"
                    >{{ document.CreationTime | date : "dd/MM/yyyy" }}
                    at
                    {{ document.CreationTime | date : "HH:mm" }}</span
                  >
                </li>
              </ul>
            </div>
            <!-- ========================== Attached Documents (End) ========================== -->
          </div>
        </div>
        <!-- ========================== Patient History Panel (End) ========================== -->

        <!-- ========================== Create New Exam Panel (Start) ========================== -->
        <div class="w50 patient-ob-box">
          <div class="h100 m-box">
            <h2>{{ pat.ID != "default" ? "Create New" : "Exams Defaults Setting" }}</h2>

            <div class="h100 l-flex l-column" style="height: fit-content">
              <div class="l-fg1">
                <div class="">
                  <!-- ========================== New Exam Type Selector (Start) ========================== -->
                  <div class="l-flex-c l-flex-w l-justify h50 new_exam-head">
                    <label
                      class="t-label-top"
                      *ngIf="showPneumology && login.category.name != 'forms'"
                    >
                      <input
                        type="radio"
                        name="TEMP_name"
                        [(ngModel)]="etype"
                        class="custom-check"
                        value="Pneumology"
                      />
                      <i class="customInput-display"></i>
                      <span> Pneumology </span>
                    </label>
                    <label
                      class="t-label-top"
                      *ngIf="!showPneumology && login.category.name != 'forms'"
                    >
                      <input
                        type="radio"
                        name="TEMP_name"
                        [(ngModel)]="etype"
                        class="custom-check"
                        value="Echo"
                      />
                      <i class="customInput-display"></i>
                      <span> Echo </span>
                    </label>

                    <label
                      class="t-label-top"
                      *ngIf="!showPneumology && login.category.name != 'forms'"
                    >
                      <input
                        type="radio"
                        name="TEMP_name"
                        [(ngModel)]="etype"
                        class="custom-check"
                        value="ECG"
                      />
                      <i class="customInput-display"></i>
                      <span> ECG </span>
                    </label>
                    <label class="t-label-top">
                      <input
                        type="radio"
                        name="TEMP_name"
                        [(ngModel)]="etype"
                        class="custom-check"
                        value="Forms"
                        style="display: none"
                      />
                      <i class="customInput-display"></i>
                      <span> Letters and Certificates </span>
                    </label>
                  </div>
                  <!-- ========================== New Exam Type Selector (End) ========================== -->

                  <div class="linked-radios-list linked-radios-set">
                    <ng-container *ngIf="etype == 'Forms'">
                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Consultation Letter"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">Consultation Letter</span>
                          <span class="linked-radios-duration"></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                      <label
                        class="linked-radios-item"
                        *ngIf="login.hasPremission('Questionnaires')"
                      >
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Send Questionnaire"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">{{ 'appointments.gui.questionnaires.New Questionnaire' | translate }}</span>
                          <span class="linked-radios-duration"></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                    </ng-container>

                    <ng-container *ngIf="etype == 'Echo'">
                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="TTE Adults"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">TTE Adults</span>
                          <span class="linked-radios-duration"><img *ngIf="defaults && defaults['TTE Adults']" src="../../assets/icons/del.svg" matTooltip="Delete" (click)="deleteDefault('TTE Adults')"/></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>

                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="TTE Pediatric"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">TTE Pediatric</span>
                          <span class="linked-radios-duration"><img *ngIf="defaults && defaults['TTE Pediatric']" src="../../assets/icons/del.svg" matTooltip="Delete" (click)="deleteDefault('TTE Pediatric')"/></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>

                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Stress-Echo"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">Stress-Echo</span>
                          <span class="linked-radios-duration"><img *ngIf="defaults && defaults['Stress-Echo']" src="../../assets/icons/del.svg" matTooltip="Delete" (click)="deleteDefault('Stress-Echo')"/></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>

                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Duplex Carotid"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">Duplex Carotid</span>
                          <span class="linked-radios-duration"><img *ngIf="defaults && defaults['Duplex Carotid']" src="../../assets/icons/del.svg" matTooltip="Delete" (click)="deleteDefault('Duplex Carotid')"/></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                    </ng-container>

                    <ng-container *ngIf="etype == 'ECG'">
                      <label class="linked-radios-item" style="color: gray">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Resting ECG"
                          [(ngModel)]="examname"
                          disabled
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">Resting ECG</span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>

                      <label class="linked-radios-item">
                        <input type="radio" name="TEMP_name1" value="Stress" [(ngModel)]="examname" />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">Stress (Ergometry)</span>
                          <span class="linked-radios-duration"><img *ngIf="defaults && defaults['Stress']" src="../../assets/icons/del.svg" matTooltip="Delete" (click)="deleteDefault('Stress')"/></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                      <label *ngIf="login.hasPremission('holterECG')" class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Holter ECG"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">Holter ECG</span>
                          <span class="linked-radios-duration"><img *ngIf="defaults && defaults['Holter ECG']" src="../../assets/icons/del.svg" matTooltip="Delete" (click)="deleteDefault('Holter ECG')"/></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                    </ng-container>
                    <ng-container *ngIf="etype == 'Pneumology'">
                      <label class="linked-radios-item" style="color: gray" *ngIf="login.hasPremission('Pneumology')">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Pulmonary functional assessment"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">Pulmonary functional assessment</span>
                        </span>
                      </label>
                      <label class="linked-radios-item" style="color: gray" *ngIf="login.hasPremission('Methacholine')">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Methacholine test"
                          [(ngModel)]="examname"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">Methacholine test</span>
                        </span>
                      </label>
                    </ng-container>
                  </div>
                </div>
              </div>

              <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">
                <a class="patient-ob-btn -exit_patient" routerLink="/patsearch">
                  {{ pat.ID != "default" ? "Exit Patient" : "Exit Defaults" }}
                </a>
                <button
                  class="patient-ob-btn -start_exam"
                  [ngClass]="examname && etype ? '' : 'opaque'"
                  [disabled]="!login.isCardio && !login.category.canCreate.exam"
                  (click)="startExam()"
                  *ngIf="canOpen() && etype != 'GastroForms'"
                >
                  {{
                    pat.ID != "default"
                      ? examname == "Send Questionnaire"
                        ? ("appointments.gui.questionnaires.New Questionnaire" | translate)
                        : etype != "Forms" && etype != "GastroForms"
                        ? "Start Exam"
                        : etype == "GastroForms"
                        ? "New Form"
                        : "New Letter"
                      : "Construct/Edit Defaults"
                  }}
                </button>
                <button
                  class="patient-ob-btn -start_exam"
                  [ngClass]="examname && etype ? '' : 'opaque'"
                  [disabled]="!login.category.canCreate.form"
                  (click)="startForm()"
                  *ngIf="etype == 'GastroForms'"
                >
                  {{ pat.ID != "default" ? "New Form" : "Construct/Edit Defaults" }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- ========================== Create New Exam Panel (End) ========================== -->
      </div>
      <!-- box margin -->
    </main>
    <!-- ========================== Dashboard Main Content (End) ========================== -->

    <!-- ========================== Main Sidebar (Start) ========================== -->

    <aside class="l-sidebar l-flex l-column">
      <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

      <!-- ========================== User Info Panel (Start) ========================== -->
      <div class="userPanel" *ngIf="pat.ID != 'default'">
        <i class="userPanel-icon icon-female">
          <button class="btn-user_data" aria-label="user data" (click)="showPat = true"></button>
        </i>

        <div class="userPanel-userName">
          {{ pat.First + " " + pat.Last }}
        </div>

        <dl class="l-table userPanel-userInfo">
          <div class="l-row">
            <dt class="l-td-m">ID Number</dt>
            <dd class="l-td-m">{{ pat.ID }}</dd>
          </div>
          <div class="l-row">
            <dt class="l-td-m">Age</dt>
            <dd class="l-td-m">{{ patService.getAgeMo() }}</dd>
          </div>
          <div class="l-row" style="margin-top: 1em" *ngIf="login.getArchiveServer()">
            <dt class="l-td-m">History</dt>
            <dd class="l-td-m">
              <a target="_blank" [href]="login.getArchiveServer() + pat.ID"
                ><img src="../../assets/icons/oldarchive.svg" style="height: 2.2em; margin-top: 1em"
              /></a>
            </dd>
          </div>
        </dl>
      </div>
      <!-- ========================== User Info Panel (End) ========================== -->

      <!-- ========================== Main Navigation (Start) ========================== -->
      <nav class="mainNav l-fg1 scroller"></nav>
      <!-- ========================== Main Navigation (End) ========================== -->

      <app-docpanel></app-docpanel>
    </aside>

    <!-- ========================== Main Sidebar (End) ========================== -->

    <app-bottombar></app-bottombar>
  </div>
  <!-- end wrapper -->
  <!-- ========================== Delete Confirmation Popup (Start) ========================== -->
  <div class="t-popup popup-patientDetails" *ngIf="toDelete" style="display: block; max-width: 40vw">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="toDelete = null; readydelete = false"
        ></button>
        <h2 *ngIf="documentDelete" style="color: #d7a95b">
          {{ "Delete document from " + (toDelete.CreationTime | date : "d/M/yy, HH:mm a") }}?
        </h2>
        <h2 *ngIf="!documentDelete" style="color: #d7a95b">
          Delete {{ toDelete.ExamType }}
          {{ defaults ? "defaults" : "exam from " + (toDelete.CreationTime | date : "d/M/yy, HH:mm") }}?
        </h2>
        <!-- box (end) -->
        <div *ngIf="!readydelete">
          <button (click)="readydelete = true">yes</button>
          <button (click)="toDelete = null; readydelete = false" style="margin-left: 2em">no</button>
        </div>
        <div *ngIf="readydelete && documentDelete">
          <strong>
            WARNING document Will Be Lost!
            <br />
          </strong>
          <button
            (click)="deleteDocument(); toDelete = null; readydelete = false; documentDelete = false"
          >
            OK
          </button>
          <button
            (click)="toDelete = null; readydelete = false; documentDelete = false"
            style="margin-left: 2em"
          >
            Cancel
          </button>
        </div>
        <div *ngIf="readydelete && !documentDelete">
          WARNING exam data and media will we lost!<br />
          <button (click)="deleteExam()">OK</button>
          <button (click)="toDelete = null; readydelete = false" style="margin-left: 2em">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <!-- ========================== Delete Confirmation Popup (End) ========================== -->

  <!-- ========================== Delete Not Allowed Popup (Start) ========================== -->
  <div class="t-popup popup-patientDetails" *ngIf="deleteDenied" style="display: block; max-width: 40vw">
    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button class="t-btn-popup-close" aria-label="close popup" (click)="deleteDenied = ''"></button>
        <h2 style="color: #d7a95b">Delete not allowed</h2>
        <div>
          {{ deleteDenied }}<br />
          <button (click)="deleteDenied = ''">OK</button>
        </div>
      </div>
    </div>
  </div>
  <!-- ========================== Delete Not Allowed Popup (End) ========================== -->

  <!-- ========================== Dynamic Popup Components (Start) ========================== -->
  <app-patdetails *ngIf="showPat" [pat]="pat" (closed)="showPat = false"></app-patdetails>
  <app-patforms *ngIf="typeForm" (closed)="typeForm = false"></app-patforms>
  <app-informconcent
    *ngIf="inform"
    (closed)="closCalForm($event)"
    [form]="concentForm"
    [ExamType]="examname"
  ></app-informconcent>
  <app-pat-documents
    *ngIf="openDocumentsAdd"
    (closed)="openDocumentsAdd = false; resetPregs()"
  ></app-pat-documents>

  <app-commerror></app-commerror>
  <app-calexams
    *ngIf="calendarForm"
    (closed)="closCalForm($event)"
    [selectedForm]="selectedForm"
  ></app-calexams>
  <app-loginbox
    *ngIf="showLogin"
    (closed)="showLogin = false"
    (viewonly)="viewonly()"
    [isnew]="newExam"
  ></app-loginbox>
  <app-closepregnancy
    *ngIf="closePreg"
    [pregtoload]="closePreg"
    [exams]="pregExams"
    (examClosed)="pregClosed()"
    (closed)="closePreg = null"
  ></app-closepregnancy>
  <app-send-questionnaire
    *ngIf="showSendQuestionnaire"
    [patient]="sendQuestionnairePatient"
    (closed)="onSendQuestionnaireClosed()"
  ></app-send-questionnaire>
  <!-- ========================== Dynamic Popup Components (End) ========================== -->
</div>
